import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Orb } from "@/components/earnos/Orb";

export default function ProtectedRoute({ children, requireOnboarded = true }) {
  const { user, loading, authError, retrySession } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-surface flex items-center justify-center">
        <Orb state="thinking" size={120} />
      </div>
    );
  }

  if (authError) return <div role="alert" className="min-h-screen bg-surface flex flex-col items-center justify-center gap-4 p-6 text-ink">
    <p>{authError}</p>
    <button type="button" className="rounded-xl bg-brand px-5 py-3 font-bold text-white" onClick={retrySession}>Retry connection</button>
  </div>;

  if (!user) return <Navigate to="/auth" replace state={{ from: location }} />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;

  return children;
}
